// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f11cccee","57":"6f44295a","455":"6c887da0","501":"f7f1ecb8","977":"ce3776e3"}[chunkId] + ".chunk.js";
};